module.exports = __webpack_public_path__ + "img/sert2Big.67ed0fb5.png";